import { NgcCartResponseMapper } from 'shared/types/ngcCart';
import { CybersourceErrorCode, findReasonCode } from './cybersourceReasonCodeMapper';

// TODO: remove this function once useCart hook is removed
export const parseNGCResponseForCart = (response: any): NgcCartResponseMapper => {
  return {
    isError: response.isError,
    error: response.isError ? JSON.parse(response.error.message.split('Error: ')[1]) : undefined,
    data: !response.isError ? response.data : undefined,
  };
};

export enum NgcErrorCodes {
  CART_NOT_FOUND = '404211',
  OPERATION_NOT_PERMITTED = '403001',
  SHIPPING_ADDRESS_NOT_FOUND = '404521',
  SHIPPING_METHOD_NOT_FOUND = '404504',
  RESOURCE_NOT_FOUND = '405070',
  SHIPPING_ADDRESS_NULL = '4004100',
  SHIPPING_METHOD_ERROR = '404521',
  SHIPPING_METHOD_NOT_ENABLED_OR_ALLOWED = '4004101',
  DATA_MISSING = '5004521',
  SHIPPING_RATE_INPUT_UPDATE_FAILED = '4004010',
  DATA_LIST_SIZE_DOES_NOT_MATCH = '400408',
  DISCOUNT_CODE_DOES_NOT_EXIST = '400474',
  DISCOUNT_CODE_TIME_RANGE_NOT_APPLICABLE = '400464',
  DISCOUNT_CODE_NOT_APPLICABLE = '400466',
  DISCOUNT_CODE_MAX_APPLICATION_REACHED = '400468',
  MAX_ALLOWED_DISCOUNT_CODE_ERROR = '400470',
  DISCOUNT_CODE_NOT_FOUND = '404429',
  GET_SESSIONS_ERROR = '4005049',
  CARD_BILLING_ADDRESS_INVALID = '4005068',
  EMAIL_INVALID = '4005070',
  CARD_HOLDER_NAME_INVALID = '4005067',
  JWT_TOKEN_INVALID = '4005066',
  PARTNERUUID_INVALID = '4005065',
  LINEITEM_PRICE_CANNOT_BE_ZERO = '4006001',
  LINEITEM_PRICE_CANNOT_BE_NULL = '4006002',
  MISSING_SHIPPING_METHOD = '4006011',
  INVALID_SHIPPIN_ADDRESS_FIELD = '4006012',
  PAYMENT_INFO_NOT_FOUND = '4006014',
  INVALID_TOTAL_LINE_ITEM_QUANTITY = '4006015',
  ORDER_PRICE_CANNOT_BE_ZERO = '4006017',
  MULTIPLE_PAYMENTS_ON_THE_CART = '4006018',
  INVALID_BILLING_ADDRESS_FIELD = '4006019',
  AUTHORIZE_PAYMENT_ERROR = '4006020',
  INVALID_CURRENCY = '4006013',
  ORDER_INTERNAL_SERVER_ERROR = '5004005',
  ORDER_ITEMS_UNAVAILABLE = '4006022',
  CYBERSOURCE_PAYMENT_AUTH_FAILED = '4005171',
  CHECKOUT_TIMEOUT_ERROR = '599',
  CART_ALREADY_ORDERED = '4006024',
}

export const cybersourceErrorMapping: Record<string, CybersourceErrorCode> = {
  'INVALID_REQUEST | MISSING_FIELD': CybersourceErrorCode.MISSING_FIELD,
  'INVALID_REQUEST | INVALID_DATA': CybersourceErrorCode.INVALID_DATA,
  'INVALID_REQUEST | DUPLICATE_REQUEST': CybersourceErrorCode.DUPLICATE_REQUEST,
  'PARTIAL_AUTHORIZED | N/A': CybersourceErrorCode.PARTIAL_APPROVAL,
  'SERVER_ERROR | SYSTEM_ERROR': CybersourceErrorCode.SYSTEM_ERROR,
  'SERVER_ERROR | SERVER_TIMEOUT': CybersourceErrorCode.SERVER_TIMEOUT,
  'AUTHORIZED_PENDING_REVIEW | AVS_FAILED': CybersourceErrorCode.AVS_FAILED,
  'AUTHORIZED_PENDING_REVIEW | CONTACT_PROCESSOR': CybersourceErrorCode.CONTACT_PROCESSOR,
  'DECLINED | EXPIRED_CARD': CybersourceErrorCode.EXPIRED_CARD,
  'DECLINED | PROCESSOR_DECLINED': CybersourceErrorCode.PROCESSOR_DECLINED,
  'DECLINED | INSUFFICIENT_FUND': CybersourceErrorCode.INSUFFICIENT_FUNDS,
  'DECLINED | STOLEN_LOST_CARD': CybersourceErrorCode.STOLEN_LOST_CARD,
  'DECLINED | ISSUER_UNAVAILABLE': CybersourceErrorCode.ISSUER_UNAVAILABLE,
  'DECLINED | UNAUTHORIZED_CARD': CybersourceErrorCode.UNAUTHORIZED_CARD,
  'DECLINED | CVN_NOT_MATCH': CybersourceErrorCode.CVN_NOT_MATCH,
  'DECLINED | EXCEEDS_CREDIT_LIMIT': CybersourceErrorCode.EXCEEDS_CREDIT_LIMIT,
  'DECLINED | INVALID_CVN': CybersourceErrorCode.INVALID_CVN,
  'DECLINED | DECLINED_CHECK': CybersourceErrorCode.DECLINED_CHECK,
  'DECLINED | BLACKLISTED_CUSTOMER': CybersourceErrorCode.BLACKLISTED_CUSTOMER,
  'DECLINED | SUSPENDED_ACCOUNT': CybersourceErrorCode.SUSPENDED_ACCOUNT,
  'AUTHORIZED_PENDING_REVIEW | CV_FAILED': CybersourceErrorCode.CV_FAILED,
  'DECLINED | INVALID_ACCOUNT': CybersourceErrorCode.INVALID_ACCOUNT,
  'INVALID_REQUEST | CARD_TYPE_NOT_ACCEPTED': CybersourceErrorCode.CARD_TYPE_NOT_ACCEPTED,
  'DECLINED | GENERAL_DECLINE': CybersourceErrorCode.GENERAL_DECLINE,
  'INVALID_REQUEST | INVALID_MERCHANT_CONFIGURATION': CybersourceErrorCode.INVALID_MERCHANT_CONFIGURATION,
  'INVALID_REQUEST | EXCEEDS_AUTH_AMOUNT': CybersourceErrorCode.EXCEEDS_AUTH_AMOUNT,
  'INVALID_REQUEST | PROCESSOR_UNAVAILABLE': CybersourceErrorCode.PROCESSOR_UNAVAILABLE,
  'INVALID_REQUEST | AUTH_ALREADY_REVERSED': CybersourceErrorCode.AUTH_ALREADY_REVERSED,
  'INVALID_REQUEST | TRANSACTION_ALREADY_SETTLED': CybersourceErrorCode.TRANSACTION_ALREADY_SETTLED,
  'INVALID_REQUEST | INVALID_AMOUNT': CybersourceErrorCode.INVALID_AMOUNT,
  'INVALID_REQUEST | INVALID_CARD_TYPE': CybersourceErrorCode.INVALID_CARD_TYPE,
  'INVALID_REQUEST | INVALID_PAYMENT_ID': CybersourceErrorCode.INVALID_PAYMENT_ID,
  'INVALID_REQUEST | MISSING_AUTH': CybersourceErrorCode.MISSING_AUTH,
  'INVALID_REQUEST | TRANSACTION_ALREADY_REVERSED_OR_SETTLED':
    CybersourceErrorCode.TRANSACTION_ALREADY_REVERSED_OR_SETTLED,
  'INVALID_REQUEST | NOT_VOIDABLE': CybersourceErrorCode.NOT_VOIDABLE,
  'INVALID_REQUEST | CAPTURE_ALREADY_VOIDED': CybersourceErrorCode.CAPTURE_ALREADY_VOIDED,
  'DECLINED | BOLETO_DECLINED': CybersourceErrorCode.BOLETO_DECLINED,
  'SERVER_ERROR | PROCESSOR_TIMEOUT': CybersourceErrorCode.PROCESSOR_TIMEOUT,
  'DECLINED | DEBIT_CARD_USAGE_LIMIT_EXCEEDED': CybersourceErrorCode.DEBIT_CARD_USAGE_LIMIT_EXCEEDED,
  'INVALID_REQUEST | ACCOUNT_NOT_ALLOWED_CREDIT': CybersourceErrorCode.ACCOUNT_NOT_ALLOWED_CREDIT,
  'REJECTED | SCORE_EXCEEDS_THRESHOLD': CybersourceErrorCode.SCORE_EXCEEDS_THRESHOLD,
  'DECLINED | APARTMENT_NUMBER_NOT_FOUND': CybersourceErrorCode.APARTMENT_NUMBER_NOT_FOUND,
  'DECLINED | INSUFFICIENT_ADDRESS_INFORMATION': CybersourceErrorCode.INSUFFICIENT_ADDRESS_INFORMATION,
  'DECLINED | HOUSE_OR_BOX_NUMBER_NOT_FOUND': CybersourceErrorCode.HOUSE_OR_BOX_NUMBER_NOT_FOUND,
  'DECLINED | MULTIPLE_ADDRESS_MATCHES': CybersourceErrorCode.MULTIPLE_ADDRESS_MATCHES,
  'DECLINED | BOX_NUMBER_NOT_FOUND': CybersourceErrorCode.BOX_NUMBER_NOT_FOUND,
  'DECLINED | ROUTE_SERVICE_NOT_FOUND': CybersourceErrorCode.ROUTE_SERVICE_NOT_FOUND,
  'DECLINED | STREET_NAME_NOT_FOUND': CybersourceErrorCode.STREET_NAME_NOT_FOUND,
  'DECLINED | POSTAL_CODE_NOT_FOUND': CybersourceErrorCode.POSTAL_CODE_NOT_FOUND,
  'DECLINED | UNVERIFIABLE_ADDRESS': CybersourceErrorCode.UNVERIFIABLE_ADDRESS,
  'DECLINED | MULTIPLE_ADDRESS_MATCHES_INTERNATIONAL': CybersourceErrorCode.MULTIPLE_ADDRESS_MATCHES_INTERNATIONAL,
  'DECLINED | ADDRESS_MATCH_NOT_FOUND': CybersourceErrorCode.ADDRESS_MATCH_NOT_FOUND,
  'DECLINED | UNSUPPORTED_CHARACTER_SET': CybersourceErrorCode.UNSUPPORTED_CHARACTER_SET,
  'PENDING_AUTHENTICATION | CONSUMER_AUTHENTICATION_REQUIRED': CybersourceErrorCode.CONSUMER_AUTHENTICATION_REQUIRED,
  'DECLINED | CONSUMER_AUTHENTICATION_FAILED': CybersourceErrorCode.CONSUMER_AUTHENTICATION_FAILED,
  'DECLINED | CUSTOMER_AUTHENTICATION_REQUIRED': CybersourceErrorCode.CUSTOMER_AUTHENTICATION_REQUIRED,
  'AUTHORIZED_PENDING_REVIEW | DECISION_PROFILE_REVIEW': CybersourceErrorCode.DECISION_PROFILE_REVIEW,
  'AUTHORIZED_RISK_DECLINED | DECISION_PROFILE_REJECT': CybersourceErrorCode.DECISION_PROFILE_REJECT,
  'DECLINED | RISK_CONTROL_DECLINE': CybersourceErrorCode.RISK_CONTROL_DECLINE,
  'DECLINED | CUSTOMER_WATCHLIST_MATCH': CybersourceErrorCode.CUSTOMER_WATCHLIST_MATCH,
  'DECLINED | ADDRESS_COUNTRY_WATCHLIST_MATCH': CybersourceErrorCode.ADDRESS_COUNTRY_WATCHLIST_MATCH,
  'DECLINED | EMAIL_COUNTRY_WATCHLIST_MATCH': CybersourceErrorCode.EMAIL_COUNTRY_WATCHLIST_MATCH,
  'DECLINED | IP_COUNTRY_WATCHLIST_MATCH': CybersourceErrorCode.IP_COUNTRY_WATCHLIST_MATCH,
};

export const getCybersourceErrorCode = (errors: any): number | null => {
  if (!errors || errors?.length === 0) return null;
  const errorMsg = errors[0].message.split(' | ');
  const key = errorMsg.length == 2 ? errorMsg[0] : errorMsg.slice(0, 2).join(' | ');
  return findReasonCode(key);
};

export enum ERROR_TYPE {
  GENERIC_ERROR,
  SHIPPING_ERROR,
  PAYMENT_ERROR,
  PLACE_ORDER_ERROR,
}

export type errorObj = {
  errors: { message: string }[];
  code: string;
};

export const ngcErrorInitialState: errorObj = { errors: [{ message: '' }], code: '' };
